import AutocompleteControl from '@/components/Form/AutocompleteControl';
import { getFieldErrorProps } from '@/helpers/form';
import { useAppSelector } from '@/store/hooks';
import { selectAdvertisersCategories } from '@/store/selectors/advertisers.selectors';
import { DOMAIN_HINT, DOMAIN_RULES } from '@/utils/validationRules';
import { InputLabel, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

const AddAdvertiserInfo = () => {
  const { control } = useFormContext();
  const categories = useAppSelector(selectAdvertisersCategories);

  return (
    <>
      <div>
        <InputLabel htmlFor='name'>
          Name<span className='text-[#fe4033]'>*</span>
        </InputLabel>
        <Controller
          name='name'
          control={control}
          rules={{
            required: {
              value: true,
              message: 'Please enter name',
            },
          }}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              fullWidth
              placeholder='Enter Advertiser Name'
              id='name'
              {...getFieldErrorProps(fieldState)}
            />
          )}
        />
      </div>
      <div className='mt-4'>
        <InputLabel htmlFor='client'>Client</InputLabel>
        <Controller
          name='client'
          control={control}
          disabled
          render={({ field, fieldState }) => (
            <TextField {...field} fullWidth placeholder='Client' id='client' {...getFieldErrorProps(fieldState)} />
          )}
        />
      </div>
      <div className='mt-4'>
        <InputLabel htmlFor='domain'>
          Domain<span className='text-[#fe4033]'>*</span>
        </InputLabel>
        <Controller
          name='domain'
          control={control}
          rules={DOMAIN_RULES}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              fullWidth
              placeholder='https://'
              id='domain'
              helperText={fieldState.error?.message || DOMAIN_HINT}
              {...getFieldErrorProps(fieldState)}
            />
          )}
        />
      </div>
      <div className='mt-4 flex gap-[15px]'>
        <div className='flex-1'>
          <InputLabel htmlFor='category'>
            Advertiser Category<span className='text-[#fe4033]'>*</span>
          </InputLabel>
          <AutocompleteControl
            required
            control={control}
            options={categories}
            name='category'
            id='category-select'
            placeholder='Select Category'
          />
        </div>
        <div className='flex-1'>
          <InputLabel htmlFor='alternativeId'>Alternative ID</InputLabel>
          <Controller
            name='alternativeId'
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                fullWidth
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                placeholder='Enter ID'
                id='alternativeId'
              />
            )}
          />
        </div>
      </div>
    </>
  );
};

export default AddAdvertiserInfo;
